angular.module('iqxCore')
/*
  This allows us to show a bit of text before a variable is ready to be displayed
 */
.filter('placeholder', [function() {
  return function (input,phvalue) {
    return (angular.isUndefined(input) || input == '') ? phvalue : input;
  }
}])